'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThreadChannels = undefined;

var _reselect = require('reselect');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getThreads = require('./getThreads');

var _isPersistedThread = require('../../thread-histories/operators/isPersistedThread');

var getThreadChannels = exports.getThreadChannels = (0, _reselect.createSelector)([_getThreads.getThreads], function (threads) {
  return threads.valueSeq().filter(_isPersistedThread.isPersistedThread).map(_threadGetters.getChannel).toArray();
});


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/getThreadChannels.js
// module id = 805
// module chunks = 2 3